export default __webpack_public_path__ + "bml-characteristic5.1a5311d.png";